// extracted by mini-css-extract-plugin
export var section = "index-module--section--UV-3q";
export var sectionbackground = "index-module--sectionbackground--2qzeb";
export var mainImg = "index-module--mainImg--8PZu7";
export var title = "index-module--title--1eBF1";
export var imgContainer = "index-module--imgContainer--3sqhv";